export default () => {

  const componentClassname = 'js-any-responsive-nav',
        $anyInstances = $(`.${componentClassname}`),
        navClassname = 'js-any-responsive-nav-nav',
        navItemClassname = 'js-any-responsive-nav-item',
        moreItemClassname = 'js-any-responsive-nav-more',
        moreBtnClassname = 'js-any-responsive-nav-more-btn',
        runinClassname = 'js-any-responsive-nav-runin',
        constrainClassname = 'js-any-responsive-nav-constrain';

  if (!$anyInstances.length) {
    return;
  }

  /**
   * @function anyResponsiveNav
   * @param  { Object } instance
   * @return { void }
  */
  const anyResponsiveNav = (instance) => {
    const $instance = $(instance),
          $nav = $instance.find(`.${navClassname}`),
          $navFirstLevel = $nav.find(`.${constrainClassname} > ul`),
          $parentLi = $nav.find(`.${constrainClassname} > ul > li[data-children="true"]`),
          $moreLi = $navFirstLevel.find(`.${moreItemClassname}`),
          $moreBtn = $navFirstLevel.find(`.${moreBtnClassname}`),
          $ulToPopulate = $navFirstLevel.find(`.${moreItemClassname} > ul`);

    let resizeTimeout,
        $lastTopLevelItemClicked,
        isInit = true;

    if (!$nav.length) {
      return;
    }

    /**
     * @function CalculateNav
     * @return { void }
    */
    const calculateNav = () => {
      const moreWidth = $moreLi.outerWidth(true) || 0,
            runinWidth = $navFirstLevel.find(`.${runinClassname}`).outerWidth(true) || 0,
            availableWidth = $nav.find(`.${constrainClassname}`).outerWidth(true) - moreWidth - runinWidth;

      let navWidth = 0,
          recursiveTimeout;

      // identify list items that are not the runin nor the "more" button
      $navFirstLevel.find(`> li:not(.${moreItemClassname}):not(.${runinClassname})`).each((i, el) => {
        navWidth += $(el).outerWidth(true);
      });

      if (navWidth > availableWidth) {
        // move item into the "more" dropdown
        const $lastItem = $navFirstLevel.find(`> li:not(.${moreItemClassname}):not(.${runinClassname})`).last();

        $lastItem.attr('data-width', $lastItem.outerWidth(true));
        $lastItem.prependTo($ulToPopulate);

        if (recursiveTimeout) {
          window.cancelAnimationFrame(recursiveTimeout);
        }

        // Setup the new requestAnimationFrame()
        recursiveTimeout = window.requestAnimationFrame(() => {
          // Continue running recalc until navWidth is not > than availableWidth
          calculateNav();
        });

      } else {
        // pull item back out from inside the "more" dropdown
        const $firstMoreItem = $navFirstLevel.find(`.${moreItemClassname} > ul > li`).first();

        if (navWidth + $firstMoreItem.data('width') < availableWidth) {
          $firstMoreItem.insertBefore($moreLi);
        }
      }

      // if the "more" dropdown has items, show the "more" button
      if ($navFirstLevel.find(`.${moreItemClassname} > ul > li`).length > 0) {
        $moreLi.addClass('js-visible');
      } else {
        // hide "more" button
        $moreLi.removeClass('js-visible');
      }

      // if "more" has become the only child (including no runout text),
      // swap out its label for something clearer
      if ($moreLi.is(':only-child') && $moreBtn.data('onlychildLabel')) {
        $moreBtn.text($moreBtn.data('onlychildLabel'));
      } else {
        $moreBtn.text($moreBtn.data('defaultLabel'));
      }

      if (isInit) {
        $instance.addClass('js-initialized');
      }

      isInit = false;
    };


    /**
     * Close any open menu by triggering focusout events
     * and clear out $lastTopLevelItemClicked var
     *
     * @function clearLastItemClicked
     * @return { void }
    */
    const clearLastItemClicked = () => {
      if ($lastTopLevelItemClicked) {
        $lastTopLevelItemClicked.blur();
        $lastTopLevelItemClicked.find('button, li').blur();

        // reset since a toggle can only happen once per el anyway
        $lastTopLevelItemClicked = null;
      }
    };


    /**
     * @function toggleOpenState
     * @param  { Boolean } doOpen
     * @param  { Object } $li
     * @return { void }
    */
    const toggleOpenState = (doOpen = false, $li) => {
      const $targetLi = $li,
            $targetLiBtn = $li.find(' > .js-no-link'),
            $targetDropdown = $li.find('.js-submenu');

      // NOTE: may have two levels of js-submenu

      if (doOpen) {
        $targetLi.attr('data-expanded', true);
        $targetLiBtn.attr('aria-expanded', true);
        $targetDropdown.attr('aria-hidden', false);
      } else {
        $targetLi.attr('data-expanded', false);
        $targetLiBtn.attr('aria-expanded', false);
        $targetDropdown.attr('aria-hidden', true);
      }
    };


    /**
     * Behavior for main item (parent of menu) or "more" to show its dropdown
     * @function doItemFocusIn
     * @param { Object } $li
     * @return { void }
    */
    const doItemFocusIn = ($li) => {
      // first, close any other open menus and the "more" menu
      $parentLi.each((i, el) => {
        toggleOpenState(false, $(el));
      });

      toggleOpenState(false, $moreLi);

      // now open the focused element's menu
      toggleOpenState(true, $li);
    };


    /**
     * Behavior for main item (parent of menu) or "more" to hide its dropdown
     * @function doItemFocusOut
     * @param { Object } $li
     * @return { void }
    */
    const doItemFocusOut = ($li) => {
      toggleOpenState(false, $li);
    };


    /**
     * Behavior for main item (parent of menu) or "more" click to set last focused element
     * this allows a click to become a toggle for each dropdown
     *
     * @function doItemClick
     * @param { Object } $li
     * @return { void }
    */
    const doItemClick = ($li) => {
      // toggle focus on click; compare dom objects to see if this is last item clicked
      // if this is the same LI that was last clicked, close its menu (toggle)
      // by removing focus (button) and focusin (li)
      if ($lastTopLevelItemClicked && $li[0] === $lastTopLevelItemClicked[0]) {
        clearLastItemClicked();
      } else {
        // save record for next time around (to detect toggle)
        $lastTopLevelItemClicked = $li;
      }
    };


    /**
     * DEV NOTE: Wondering why there's so much JS in here?
     * It's all b/c Webkit/safari does not trigger focus events on button elements.
     * So it doesn't work to do on('focus') of an li > button.
     *
     * Separately, we can get focusin/focusout events to fire which works everywhere
     * BUT in Safari you need to set tabindex="0" on the LI for this to work.
     * But doing so creates two focusable els in normal browsers, the li and btn.
     *
     * Therefore in addition to focusin/focusout events which would normally be
     * sufficient for most browsers, for Safari we also need to have the click
     * event to handle click b/c click in safari won't trigger the focus.
     *
     *
     * @event element#focusin
     * @param { Event } e
     * @return { void }
    */
    $moreLi.on('focusin', (e) => {
      const $thisListItem = $(e.currentTarget);
      doItemFocusIn($thisListItem);
    });


    /**
     * @event element#focusout
     * @param { Event } e
     * @return { void }
    */
    $moreLi.on('focusout', (e) => {
      const $thisListItem = $(e.currentTarget);
      doItemFocusOut($thisListItem);
    });


    /**
     * @event element#focusin
     * @param { Event } e
     * @return { void }
    */
    $parentLi.on('focusin', (e) => {
      const $thisListItem = $(e.currentTarget);
      doItemFocusIn($thisListItem);
    });


    /**
     * @event element#focusout
     * @param { Event } e
     * @return { void }
    */
    $parentLi.on('focusout', (e) => {
      const $thisListItem = $(e.currentTarget);
      doItemFocusOut($thisListItem);
    });


    /**
     * @event element#click
     * @param { Event } e
     * @return { void }
    */
    $moreLi.on('click', (e) => {
      const $thisListItem = $(e.currentTarget);

      e.preventDefault();
      doItemFocusIn($thisListItem);
      doItemClick($thisListItem);
    });


    /**
     * @event element#click
     * @param { Event } e
     * @return { void }
    */
    $parentLi.on('click', (e) => {
      const $thisListItem = $(e.currentTarget);

      e.preventDefault();
      doItemFocusIn($thisListItem);
      doItemClick($thisListItem);
    });


    /**
     * Click outside to close any open state
     *
     * @function clickOutside
     * @return { void }
    */
    const clickOutside = (e) => {
      const $liParent = $(e.target).closest(`.${navItemClassname}`),
            $moreParent = $(e.target).closest(`.${moreItemClassname}`);

      if ($liParent.length === 0 && $moreParent.length === 0) {
        clearLastItemClicked();
      }
    };


    /**
     * Click-outside event will capture a click on any element
     * that does not have a main LI or "more" li parent
     * and close any open menu.
     *
     * @event body#click
     * @param { Event } e
     * @return { void }
     */
    $('body').on('click', (e) => {
      clickOutside(e);
    });


    /**
     * @event document#keydown
     * @return { void }
     */
    $(document).on('keydown', ({ key }) => {
      if (key === 'Esc' || key === 'Escape') {
        // clear out last item clicked data
        clearLastItemClicked();

        // blur any/all focusable elements in this component
        $parentLi.blur();
        $parentLi.find('button').blur();

        $moreLi.blur();
        $moreLi.find('button').blur();
      }
    });


    /**
     * @event window#resize
     * @return { void }
    */
    window.addEventListener('resize', () => {
      // If there's a timer, cancel it
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }

      // Setup the new requestAnimationFrame()
      resizeTimeout = window.requestAnimationFrame(() => {
        // Run resize functions
        calculateNav();
      });

    }, false);


    /**
     * @event window#load
     * @return { void }
    */
    calculateNav();
    $instance.addClass('js-loaded');
    $instance[0].style.setProperty('--any-responsive-nav-more-width', `${$instance.find(`.${moreBtnClassname}`).width()}px`);
  };

  // init any/all instances
  $anyInstances.each((i, el) => {
    anyResponsiveNav(el);
  });
};
